export default {
    SET_LOADING_STATE: "provinceDocuments/SET_LOADING_STATE",
    SET_PROVINCE_DOCUMENTS_DATA: "provinceDocuments/SET_PROVINCE_DOCUMENTS_DATA",
    SET_DIALOG_STATE: "provinceDocuments/SET_DIALOG_STATE",
    UPDATE_PROVINCE_DOCUMENT_FORM: "provinceDocuments/UPDATE_PROVINCE_DOCUMENT_FORM",
    RESET_FORM: "provinceDocuments/RESET_FORM",
}
